import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import Footer from '../components/Footer';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1">
        <div className="container mx-auto px-4 py-8 max-w-4xl">
          <Button onClick={() => navigate('/')} variant="ghost" className="mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver a la tienda
          </Button>

          <div className="bg-white rounded-2xl shadow-lg p-8">
            <h1 className="text-3xl font-bold mb-6 text-gray-800">Política de Privacidad</h1>
            <p className="text-sm text-gray-500 mb-8">Última actualización: Febrero 2025</p>

            <div className="prose prose-gray max-w-none space-y-6">
              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">1. Responsable del Tratamiento</h2>
                <p className="text-gray-600">
                  En cumplimiento del Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo (RGPD) y la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales (LOPD-GDD), le informamos:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-3">
                  <li><strong>Responsable:</strong> JRF SPORTSWEAR</li>
                  <li><strong>NIF:</strong> 54372237F</li>
                  <li><strong>Dirección:</strong> Plaza de la Constitución 15, 29788 Frigiliana (Málaga), España</li>
                  <li><strong>Email:</strong> infojrfsportswear@gmail.com</li>
                  <li><strong>WhatsApp:</strong> +34 611 871 722</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">2. Finalidad del Tratamiento</h2>
                <p className="text-gray-600">Tratamos sus datos personales para las siguientes finalidades:</p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-3">
                  <li><strong>Gestión de pedidos:</strong> Procesar y enviar los productos adquiridos</li>
                  <li><strong>Comunicaciones comerciales:</strong> Envío de ofertas y novedades (solo con consentimiento expreso)</li>
                  <li><strong>Atención al cliente:</strong> Resolver consultas, quejas y reclamaciones</li>
                  <li><strong>Facturación:</strong> Emisión de facturas y cumplimiento de obligaciones fiscales</li>
                  <li><strong>Mejora del servicio:</strong> Análisis estadístico anónimo del uso de la web</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">3. Legitimación del Tratamiento</h2>
                <p className="text-gray-600">La base legal para el tratamiento de sus datos es:</p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-3">
                  <li><strong>Ejecución de contrato:</strong> Para gestionar su pedido y entrega</li>
                  <li><strong>Consentimiento:</strong> Para el envío de comunicaciones comerciales</li>
                  <li><strong>Obligación legal:</strong> Para el cumplimiento de obligaciones fiscales</li>
                  <li><strong>Interés legítimo:</strong> Para la mejora de nuestros servicios y prevención del fraude</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">4. Datos Recogidos</h2>
                <p className="text-gray-600">Los datos personales que recogemos incluyen:</p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-3">
                  <li>Nombre y apellidos</li>
                  <li>Dirección de envío y facturación</li>
                  <li>Correo electrónico</li>
                  <li>Número de teléfono</li>
                  <li>Datos de pago (procesados de forma segura por Stripe/PayPal)</li>
                  <li>Historial de pedidos</li>
                  <li>Dirección IP y datos de navegación (cookies)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">5. Destinatarios de los Datos</h2>
                <p className="text-gray-600">Sus datos podrán ser comunicados a:</p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-3">
                  <li><strong>Empresas de transporte:</strong> SEUR, Correos Express, InPost (para la entrega de pedidos)</li>
                  <li><strong>Pasarelas de pago:</strong> Stripe, PayPal (para procesar pagos de forma segura)</li>
                  <li><strong>Administración tributaria:</strong> En cumplimiento de obligaciones legales</li>
                  <li><strong>Proveedores tecnológicos:</strong> Hosting y servicios cloud (con contrato de encargo de tratamiento)</li>
                </ul>
                <p className="text-gray-600 mt-2">
                  No se realizan transferencias internacionales de datos fuera del Espacio Económico Europeo, salvo a proveedores que cuentan con las garantías adecuadas (Decisión de adecuación, Cláusulas Contractuales Tipo).
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">6. Conservación de los Datos</h2>
                <p className="text-gray-600">Los datos se conservarán durante los siguientes plazos:</p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-3">
                  <li><strong>Datos de clientes:</strong> Mientras se mantenga la relación comercial y posteriormente durante el plazo de prescripción legal (5 años)</li>
                  <li><strong>Datos de facturación:</strong> 6 años (obligación fiscal)</li>
                  <li><strong>Datos de newsletter:</strong> Hasta que retire el consentimiento</li>
                  <li><strong>Cookies:</strong> Según el tipo (ver Política de Cookies)</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">7. Derechos del Usuario</h2>
                <p className="text-gray-600">Tiene derecho a:</p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-3">
                  <li><strong>Acceso:</strong> Conocer qué datos personales tratamos</li>
                  <li><strong>Rectificación:</strong> Modificar datos inexactos o incompletos</li>
                  <li><strong>Supresión:</strong> Solicitar la eliminación de sus datos ("derecho al olvido")</li>
                  <li><strong>Oposición:</strong> Oponerse al tratamiento de sus datos</li>
                  <li><strong>Limitación:</strong> Solicitar la limitación del tratamiento</li>
                  <li><strong>Portabilidad:</strong> Recibir sus datos en formato estructurado</li>
                  <li><strong>Retirar consentimiento:</strong> En cualquier momento, sin efecto retroactivo</li>
                </ul>
                <p className="text-gray-600 mt-3">
                  Para ejercer estos derechos, envíe un email a <strong>infojrfsportswear@gmail.com</strong> indicando el derecho que desea ejercer y adjuntando copia de su DNI.
                </p>
                <p className="text-gray-600 mt-2">
                  Si considera que sus derechos no han sido debidamente atendidos, puede presentar una reclamación ante la <strong>Agencia Española de Protección de Datos</strong> (www.aepd.es).
                </p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">8. Medidas de Seguridad</h2>
                <p className="text-gray-600">
                  Hemos adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad de sus datos personales:
                </p>
                <ul className="list-disc pl-6 text-gray-600 space-y-1 mt-3">
                  <li>Cifrado SSL/TLS en todas las comunicaciones</li>
                  <li>Pasarelas de pago seguras certificadas PCI-DSS</li>
                  <li>Acceso restringido a datos personales</li>
                  <li>Copias de seguridad periódicas</li>
                  <li>Sistemas de detección de intrusiones</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-bold text-gray-800 mb-3">9. Modificaciones</h2>
                <p className="text-gray-600">
                  Nos reservamos el derecho de modificar esta Política de Privacidad para adaptarla a novedades legislativas o jurisprudenciales. En caso de cambios significativos, se lo notificaremos por email o mediante un aviso destacado en la web.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;
